const EventEmitter = require('eventemitter3');

const BattleCalc = require('../../BattleCalc');
const PoisonedCondition = require('../../conditions/PoisonedCondition');
const DamageEvent = require('../../events/DamageEvent');
const { logError } = require('../../logger');

const Fumigate = function (battleState) {
  this.handle = 'fumigate';
  this.magic = true;
  this.harm = true;
  const _cause = this;

  this.eventEmitter = new EventEmitter();

  this.isLegal = () => true;

  this.execute = function (actor, victim) {
    if (!actor || !actor.inPlay) {
      return { success: false };
    }

    setTimeout(() => {
      try {
        if (!actor || !actor.inPlay) {
          return;
        }

        var result = onDelay(actor);
        result.abilityHandle = this.handle;
        result.actorId = actor.uid;
        result.allPieces = battleState.allPieces;

        this.eventEmitter.emit('result', result);
      } catch (err) {
        logError(err, {
          module: 'Fumigate',
          func: 'execute',
          actor,
          victim,
        });
      }
    }, 900);
  };

  function onDelay(actor) {
    const potency = BattleCalc.getEquippedAbility(actor, 'fumigate').potency;

    var result = {
      poisonedConditions: [],
    };

    var adjustedPotency;
    var dist;

    for (var prop in battleState.allUnits) {
      var _uVictim = battleState.allUnits[prop];
      dist = BattleCalc.boardDistance(actor, _uVictim);
      adjustedPotency = potency - ((dist - 1) * potency) / 4;

      // calculate bleed condition potency using a dummy damage event,
      // so we can apply stance adjustments, hero Affinities, etc.
      const poisonDamageDummy = new DamageEvent(
        battleState,
        actor,
        adjustedPotency,
        _cause
      );
      poisonDamageDummy.applyStanceAdjustments(_uVictim);
      adjustedPotency = poisonDamageDummy.damage;

      if (_uVictim !== actor && adjustedPotency >= 3) {
        // if the victim already has a poisoned condition with same instigator, add to its potency
        var poisoned = BattleCalc.getCondition(_uVictim, 'poisoned', actor.uid);
        if (poisoned) {
          poisoned.potency += adjustedPotency;
          battleState.updateCondition(_uVictim.uid, poisoned.uid);
          result.poisonedConditions.push(poisoned);
        } else {
          poisoned = new PoisonedCondition(
            actor,
            _uVictim,
            battleState,
            adjustedPotency
          );
          battleState.onUnitCondition(poisoned);
          result.poisonedConditions.push(poisoned);
        }
      }
    }

    return result;
  }
};
module.exports = Fumigate;
